import Vue from "vue";
import vConsole  from 'vconsole';
import VueI18n from "vue-i18n";
import { ingame, dataURLtoFile, getSys, download, isMobile } from '@tencent/pa-cms-utils';
import Aegis from 'aegis-web-sdk';

import { getRoleInfo, saveRoleInfo, RoleInfo, getLoginedInitInfo, getReward, submitShare, RewardType, RecordMessage0101, SentimentType } from "@/api/modules/page";
import { IsTest, getLang, switchLang, isInIntlBrowser, getSpecialBrowserType, imageToBase64, domToBase64 } from "@/utils/tools";
import { initServetime } from "@/api";
import { reportTlog } from "@/api/modules/report";
import { fb_app_id, REGISTER_URL, ProdServerMap, isHtm, MissionStatus, RoleCardStatus, presentMap } from "@/utils/const";
import { dynamicShare, share } from "@/utils/share";
import Login, { checkLogin } from "@/utils/login";
// import testData from "@/testData.json";
import './style.css'
import { setLanguageDialog, languageArr, closeLangDialog } from './utils/setLanguage'

Vue.use(VueI18n)
Vue.config.productionTip = false;
if (IsTest) {
  new vConsole();
}
new Aegis({
  id: '16PrDflvYgxpwzDnep', // 上报 id
  uin: Login.info()?.openid, // 用户唯一 ID（可选）
  reportApiSpeed: true, // 接口测速
  reportAssetSpeed: true, // 静态资源测速
  spa: true, // spa 应用页面跳转的时候开启 pv 计算
  hostUrl: 'https://rumt-sg.com',
  env: IsTest ? "test" : "production",
  api: {
    apiDetail: true,
  },
});
reportTlog({
  action: "red_lotus_home_page",
  sub_action: "cm_vshow"
});
(window as any).reportTlog = reportTlog;
const DEFAULT_LANG = "en";

const CMSLanguage = {
  en : 'en',
  th : 'th',
  fr : 'fr',
  de : 'de',
  pt : 'pt-all',
  es : 'es',
  id : 'id',
  ja : 'ja',
  ko : 'ko',
}
// 语言路径
const allLanguageContext= require.context('./locales', false, /\**\.js$/);
const locales = allLanguageContext.keys().reduce((pre, fileName) => {
  const componentConfig = allLanguageContext(fileName)
  const name = fileName.replace(".js", "").replace("./", "");
  return {
    ...pre,
    [name]: componentConfig.default,
  }
}, {})
export const i18n = new VueI18n({
  locale: DEFAULT_LANG,
  messages: locales,
  fallbackLocale: DEFAULT_LANG,
});
const LOCALE_KEY = "localeLanguage";

const getLangFromStorage = () => {
  const storeLang = window.localStorage.getItem(LOCALE_KEY);
  if (!storeLang) return;
  const lang = locales[storeLang as keyof typeof locales]
  if (lang === undefined) return;
  return storeLang;
}
export const setLocal = (language?: string|null) => {
  console.log("setLocal", language);
  let lang = language;
  if (lang === undefined || lang === null) {
    lang = getLangFromStorage();
  }
  if (!lang) return;
  window.localStorage.setItem(LOCALE_KEY, lang);
  i18n.locale = lang;
  // 静态Html 数据动态显示
  // document.title = i18n.t("title") as string;
  // const metas = document.getElementsByTagName("meta");
  // console.log('metas', metas)
  // const keywords = metas["keywords"];
  // const description = metas["description"];
  // if (keywords) {
  //   keywords.setAttribute("content", i18n.t("page.298"));
  // }
  // if (description) {
  //   description.setAttribute("content", i18n.t("page.299"));
  // }
};
const urlLangType = getLang();
window.setLocal = setLocal;
setLocal(urlLangType);
(window as any).lang = urlLangType;
const init = Vue.prototype._init;
Vue.prototype._init = function (options: any) {
  init.call(this, {
    i18n,
    ...options,
  });
};

// https://1024tools.com/timestamp utc+9
// const startTimestamp = 1704351600; // 2024-01-04 15:00:00
const endTimestap= 1705589940; // 2024-01-18 22:59:00
// TODO test
const startTimestamp= 1698807600; // 2023-11-1 11:00:00
// const endTimestap= 1704267000; // 2024-01-03 15:30:00

const dynamicPath = '_20231229'
new Vue<any>({
  el: "#app",
  data() {
    return {
      languageArr,
      language: urlLangType,

      roleId: 0,
      areaId: 0,

      roleList: [],
      isLogin: checkLogin(),
      choosed: false,
      serverList: ProdServerMap,
      loading: false,
      
      isInIntlBrowser,
      isHtm,

      showMask: false,

      shareImgs: [],
      isInit: false, // 是否初始化， 只有在发送请求前才会触发登录
    }
  },
  computed: {
    languageText(){
      const lang = languageArr.find(lang =>lang.value === this.language)
      if (!lang) {
        const english = languageArr.find(lang =>lang.value === 'en')
        return english?.label
      }
      return lang.label;
    },
    roleName() {
      if (!this.roleId) return '';
      const role = this.roleList.find((role: RoleInfo) => role.role_id === this.roleId);
      if (!role) return '';
      return role.role_name;
    },
    selectRoleName() {
      if (!this.roleName) return this.$t('please_select');
      return this.roleName;
    },
    serverName() {
      if (!this.areaId) return this.$t('please_select');
      const server = this.serverList.find((server: any) => server.id == this.areaId);
      if (!server) return this.$t('please_select');
      return server.name;
    },
    showNv() {
      if (this.language === 'ko') return 'naver';
      if (isHtm || this.language === 'th') return 'facebook';
      return 'twitter';
    },
    showKakao() {
      const browser = getSpecialBrowserType();
      return !isInIntlBrowser && !['facebook', 'twitter'].includes(browser)
    },
    showLine() {
      // if (this.language === 'th') return false;
      if (ingame.isInIntlBrowser && getSys().name?.toLowerCase() === 'ios') return false;
      return true
    }
  },
  watch: {
    language: {
     handler(lang) {
        window.setLocal(lang);
        // TODO 语言切换
        // const language = langMap[lang as keyof typeof langMap] || lang ;
        // const oldLanguage = langMap[oldLang as keyof typeof langMap] || oldLang ;

        // window?.languageObj.Init();
        // transformLangText(language)
        // window?.languageObj.Change(oldLanguage || 'en', language);
        const divs = languageArr.map(lang => {
          const divDom = window.$(`<a class="item" href="javascript:;" data="${lang.value}">${lang.label}</a>`);
          divDom.on('click', this.setLanguage)
          return divDom;
        })
        window.$('#langPop').empty().append(divs)

      },
      immediate: true,
    },
    areaId(val) {
      if (!val || val === '0' || !checkLogin()) return;
      this.roleList = [];
      const role = this.areaRoleMap.get(val);
      if (role) {
        this.roleList = role;
        this.buildRoleSelect();
        return;
      }
      this.loading = true;
      (window as any).gm.loading()
      this.buildRoleSelect();
      getRoleInfo({area_id: val }).then((res) => {
        if (!res || res.code !== 0) return;
        const { data } = res;
        if (!data.role_list) return;
        const { role_list: get_role_info } = data;
        this.areaRoleMap.set(val, get_role_info);
        // 异步 可能 areaId已改变
        if (val !== this.areaId) {
          return
        }
        this.roleList = get_role_info;
        if (get_role_info.length) {
          this.roleId = get_role_info[0].role_id;
        }
      }).finally(() => {
        this.loading = false;
        (window as any).gm.hideLoading()
        this.buildRoleSelect();
      })
    },
    roleName: {
      handler(val) {
        window.$("#user").text(val);
      },
     immediate: true,
    },
    showMask: {
      handler(val) {
        console.log('showMask', val)
        const mask = window.$(".livingLoading");
        if (!val) {
          if (!mask.length) return;
          mask.addClass('unshow')
          return;
        }
        if (mask.length) {
          mask.removeClass('unshow');
          return;
        }
        const maskDom = window.$('<div class="livingLoading"></div>');
        maskDom.on("click", this.clcikMask)
        maskDom.appendTo(window.$("body"))
      },
      immediate: true,
    }
  },
  beforeCreate() {
    window.showTips = (msg: string) => (window as any).gm.alert(msg)
  },
  async created(){
    window.clickReward = this.clickReward
    this.areaRoleMap = new Map();
    await Login.init()
    this.isLogin = checkLogin()
    await initServetime();
    // await this.init();
    this.addMask();
  },
  mounted(){
    (window as any).getWordAttitude = this.getWordAttitude; 
    window.$('#loginIcon').on('click', this.clickLogin)
    window.$("#logout").on("click", this.logout)
    // window.$("#langPop .item").on("click", this.setLanguage)
    window.$("#layerServer .btn").on("click", this.submitRole)
    window.$('.item_login').removeClass('on');
    this.longTouch(window.$("#pResult"), () => {
      this.getDownLoadImag();
      this.downloadImage()
    })
    this.appendShareChannel();
    window.$("#userSelectList").on("click", (event: Event) => {
      const data = window.$(event.target).attr("data");
      this.appendRewardShip(data === 'happy new year')
    });
    window.$("#loadBtn").on("click", () => reportTlog({
      action: "red_lotus_enter_btn",
      sub_action: "cm_click",
      ext_content: {
        areaid: this.areaId,
      }
    }));
    window.$("#landSlider .btn").on("touchstart", () => reportTlog({
      action: "red_lotus_phone_slide_btn",
      sub_action: "cm_click",
      ext_content: {
        areaid: this.areaId,
      }
    }));
    window.$("#talkSend").on("click", () => reportTlog({
      action: "red_lotus_confirm_btn",
      sub_action: "cm_click",
      ext_content: {
        areaid: this.areaId,
      }
    }));
    window.$("#resultAgain").on("click", () => reportTlog({
      action: "red_lotus_start_over_btn",
      sub_action: "cm_click",
      ext_content: {
        areaid: this.areaId,
      }
    }));
    window.$("#resultDownload").on("click", () => reportTlog({
      action: "red_lotus_play_nikke_now_btn",
      sub_action: "cm_click",
      ext_content: {
        areaid: this.areaId,
      }
    }));
  },
  methods: {
    async init() {
      if (checkLogin()){
        // 登录了， 异步获取 绑定区服信息
        this.getLoginedInitInfo();
      }
    },
    // 活动过期蒙层
    addMask() {
      if (window.serverTime < startTimestamp || window.serverTime > endTimestap) {
        this.showMask = true;
      }
    },
    clcikMask() {
      if (window.serverTime < startTimestamp) {
        this.showMessage(this.$t('FlowHasNotBegin'))
        return;
      }
      if (window.serverTime > endTimestap) {
        this.showMessage(this.$t('FlowHasEnd'))
        return;
      }
      this.showMask = false;
    },
    showMessage(text: string) {
      window.showTips(text);
    },
    setLanguageDialog,
    setLanguage(event: Event) {
      event.stopPropagation();
      const lang = window.$(event.target).attr("data");
     
      console.log('setLanguage', lang);
      this.language = lang;
      closeLangDialog()
      // 切换语言跳链接
      switchLang(lang);
    },
    async submitRole(){
      if (this.loading) return;
      if (!checkLogin()) {
        this.showMessage(this.$t("pls_input_info"))
        return;
      }
      if (!this.roleId || this.roleId === '0' || !this.areaId || this.areaId === '0') {
        this.showMessage(this.$t("pls_input_info"))
        return;
      }
      this.loading = true;
      try {
        const res = await saveRoleInfo({
          area_id: this.areaId,
          role_id: this.roleId,
        });
        if(res && res.code === 601009) {
          window.location.reload()
          return
        }
        if (res && res.code == 0) {
          window.$('#layerServer').fadeOut(500);
          this.choosed = true;
          this.getLoginedInitInfo();
        }
      } finally {
        this.loading = false;
      }
    },
    async trigerAreaSelect(){
      if (this.choosed) {
        // window.$('.role').fadeOut(500);
        return;
      }
      this.areaId = `${this.serverList[0].id}`;
      this.buildServerSelect();
      window.$('#layerServer').fadeIn(500);
    },
    buildServerSelect() {
      const select = window.$(`
        <select id="serverSelect">
          ${ ProdServerMap.map(item => {
            return `
              <option value=${item.id}>${item.name}</option>
            `
          }).join('\n') }
        </select>
      `)
      select.bind('change', this.handleSeverSelect);
      // select.find("option").on("click", this.handleSeverSelect)
      window.$('#layerServer .item:nth-child(1) .input select').replaceWith(select);
    },
    handleSeverSelect (event: Event){
      const value = window.$(event.target).children('option:selected').val();
      this.areaId = value;
    },
    buildRoleSelect() {
      let options = [];
      if (this.loading) {
        options = [`<option value="0" disabled>${this.$t('loading')}</option>`];
      } else {
        options = this.roleList.map((role: RoleInfo) => {
          return `
            <option value=${role.role_id}>${role.role_name}</option>
          `
        })
      }

      if (options.length === 0) {
        options = [`<option value="0" disabled>${this.$t('NoRoleInfo')}</option>`];
      }
      const select = window.$(`
        <select id="serverSelect">
          ${ options.join('\n') }
        </select>
      `)
      select.bind('change', this.handleRoleSelect);
      // select.on("click", this.handleRoleSelect)
      window.$('#layerServer .item:nth-child(2) .input select').replaceWith(select);
    },
    handleRoleSelect (event: Event){
      const value = window.$(event.target).children('option:selected').val();
      this.roleId = value;
    },
    async clickLogin(){
      // if (checkLogin()){
      //   // 登录了， 异步获取 绑定区服信息
      //   await this.getLoginedInitInfo();
      // }
      if (!await this.checkLogin()) return;
      window.$("#popLogout").fadeToggle()
    },
    logout() {
      Login.logout();
      window.location.reload()
    },
    async checkLogin() {
      if (this.isLogin && this.choosed) return true;
      if (!this.isLogin){
        // 打开登录框
        Login.login(this.language).then(async res => {
          if (res && (res.ret as any) === 0) {
            this.isLogin = true;
            await this.getLoginedInitInfo();
          }
        });
        return false;
      }
      if (!this.isInit) {
        await this.getLoginedInfo();
        this.isInit = true;
      }
      if (!this.choosed) {
        this.trigerAreaSelect()
        return false;
      }
      return this.isLogin && this.choosed;
    },
    async getLoginedInitInfo() {
      if (!this.isLogin) return;
      await this.getLoginedInfo();
      
      this.trigerAreaSelect();
    },
    clickLogout(event: Event){
      event.stopPropagation();
      window.$('.loginout_box').show();
    },
    async dynamicShare(){
      if (this.isLoading) {
        return;
      }
      (window as any).gm.loading()
      // 港澳台 不使用分享服务， 无法部署资源， 修改html查看效果
      this.isLoading = true;
      const select = (window as any).select// 用户 文本选择/输入
      const uid = `${this.language}_${this.areaId}_${this.roleId}_${select}_${dynamicPath}`;
      const shareImg = await this.getBase64Image('#shareImg', { scale: 1 })
      // 港澳台 不使用分享服务， 无法部署资源， 修改html查看效果
      if (isHtm) {
        this.dynamicShareResult = {
          // 港澳台分享地址， 由dynamicShareResult覆盖 TODO
          share_url: "https://nikke.hotcool.tw/newyearwithscarlet",
        };
        this.isLoading = false;
        (window as any).gm.hideLoading()
        return
      };
      try {
        const cmsLang = CMSLanguage[this.language as keyof typeof CMSLanguage];
        const result = await dynamicShare({
          file: dataURLtoFile(shareImg, `${uid}.jpg`).file,
          uid,
          url_querys: new URLSearchParams({ language: cmsLang }),
        })
        this.dynamicShareResult = result;
        console.log('result', result)
      } catch (e){
        this.showMessage(this.$t("serverError"))
      } finally{
        this.isLoading = false;
        (window as any).gm.hideLoading()
      }
    },
    async dynamicSquareShare(){
      if (this.isLoading) {
        return;
      }
      (window as any).gm.loading()
      const select = (window as any).select// 用户 文本选择/输入
      const uid = `kakao_${this.language}_${this.areaId}_${this.roleId}_${select}_${dynamicPath}`;
      const img = await this.getBase64Image('#shareImg2', { scale: 1 })
      try {
        const cmsLang = CMSLanguage[this.language as keyof typeof CMSLanguage];
        const result = await dynamicShare({
          file: dataURLtoFile(img as any, `${uid}.jpg`).file,
          uid,
          url_querys: new URLSearchParams({ language: cmsLang }),
        })
        this.dynamicShareResult = result;
        console.log('result', result)
      } catch (e){
        this.showMessage(this.$t("serverError"))
      } finally{
        this.isLoading = false;
        (window as any).gm.hideLoading()
      }
    },
    async share(channel: string) {
      reportTlog({
        action: "red_lotus__share_channel_btn",
        sub_action: "cm_click",
        ext_content: {
          channel_name: channel,
          areaid: this.areaId,
        }
      })
      if (this.shouldReward) {
        if (!await this.checkLogin()) return;
        this.clickReward();
      }
      if (channel === 'kakao' && this.language !== 'zh') {
        await this.dynamicSquareShare();
      } else {
        await this.dynamicShare()
      }
      if (this.isLoading || !this.dynamicShareResult) {
        this.showMessage(this.$t("laodingPic"))
        return;
      }
      // const res = await submitShare();
      // if (!res || res.code !== 0) return;
      try{
        await share({
          ...this.dynamicShareResult,
          app_id: fb_app_id,
          title: this.$t("shareContent"),
          text: this.$t("shareContent"),
          hashtag: "#NIKKE",
          channel,
        });
      } catch(error) {
        console.log('share error', error)
      }
    },
    async getBase64Image(selector: string, options = { scale: 2 }){
      const dom = document.querySelector(selector) as HTMLElement;
      if (!dom) return;
      const uri = await domToBase64(dom, { ...options })
      return uri; // 获取生成的图片的url
    },
    async getBase64ImageByDom(dom: HTMLElement, options = { scale: 2 }){
      if (!dom) return;
      const uri = await domToBase64(dom, { ...options })
      return uri; // 获取生成的图片的url
    },
    downloadImage() {
      reportTlog({
        action: "one_year_share_download_pic",
        sub_action: "cm_click",
        ext_content: {
          areaid: this.areaId,
        }
      })
      const browser = getSpecialBrowserType();
      // android 无法保存图片
      if (ingame.isInIntlBrowser && getSys().name?.toLowerCase() === 'android') {
        if (this.loading || !this.downLoadImag) {
          this.showMessage(this.$t('laodingPic'))
          return;
        }
        // 【安卓】繁中 游戏内点击游戏下载按钮出现闪退
        if (isHtm) {
          this.showMessage(this.$t("open_in_browser"));
          return
        }
        ingame.openInBrowser(this.downloadUrl || this.downLoadImag);
      } else if (['facebook', 'line', 'ins'].includes(browser) && getSys().name?.toLowerCase() === 'android') {
        // 提示
        this.showMessage(this.$t("open_in_browser"));
        return;
        // window.open(this.dynamicShareResult.image_url, '_blank');
      } else {
        if (!this.downLoadImag) {
          this.showMessage(this.$t('laodingPic'))
          return;
        }
        download({
          base64: this.downLoadImag,
          // TODO
          filename: 'newyearwithscarlet.jpg',
        });
      }
    },
    async downloadShareImg(id: number) {
      const img = this.shareImags[id];
      if (!img) return;
      const browser = getSpecialBrowserType();
      if (ingame.isInIntlBrowser && getSys().name?.toLowerCase() === 'android') {
        // 【安卓】繁中 游戏内点击游戏下载按钮出现闪退
        if (isHtm) {
          this.showMessage(this.$t("open_in_browser"));
          return
        }
        const url = this.shareUrl[id];
        ingame.openInBrowser(url||img);
      } else if (['facebook', 'line'].includes(browser) && getSys().name?.toLowerCase() === 'android') {
        // 提示
        this.showMessage(this.$t("open_in_browser"));
        return;
        // window.open(this.dynamicShareResult.image_url, '_blank');
      } else {
        download({
          base64: img,
          filename: `1st Anniversary report${id + 1}.jpg`,
        });
      }
    },
    getDownLoadImag() {
      this.loading = true;
      const img = window.$('#posterImg').attr("src")
      this.loading = false;
      this.downLoadImag = img;
    },
    async clickStart() {
      if (!await this.checkLogin()) return;
     (window as any).buildlandSlider()
    },
    clickShare() {
      reportTlog({
        action: "one_year_share_btn",
        sub_action: "cm_click",
        ext_content: {
          areaid: this.areaId,
        }
      })
    },
    async clickReward(){
      if (!await this.checkLogin()) return;
      try {
        this.rewardLoading = true;
        getReward();
      } finally {
        this.rewardLoading = false;
      }
    },
    async getLoginedInfo() {
      const res = await getLoginedInitInfo()
      if (!res || res.code !== 0) return;
      const { data } = res;
      const { get_saved_role_info } = data;
      this.choosed = !!get_saved_role_info;
      if (this.isLogin && this.choosed) {
        window.$('.item_login').addClass('on');
      } else {
        window.$('.item_login').removeClass('on');
      }
      if (get_saved_role_info) {
        const { area_id, role_id }  = get_saved_role_info || {};
        this.roleList = [get_saved_role_info];
        this.areaId = area_id;
        this.roleId = role_id;
        this.areaRoleMap.set(area_id, [get_saved_role_info]);
      } else {
        this.roleList = [];
        this.areaId = 0;
        this.roleId = 0;
      }
    },
    getOpenTwitterLink(e: Event) {
      e.preventDefault();
      interface LinkMap {
        [key: string]: {
          pc: string;
          mobile: string;
        };
      }
      const linkMap: LinkMap = {
        en: {
          pc: 'https://twitter.com/NIKKE_en',
          mobile: 'https://twitter.com/NIKKE_en'
        },
        ja: {
          pc: 'https://twitter.com/NIKKE_japan',
          mobile: 'https://twitter.com/NIKKE_japan'
        },
        ko: {
          pc: 'https://game.naver.com/lounge/nikke/board/11',
          mobile: 'https://m.game.naver.com/lounge/nikke/board/11'
        }
      }
      const link = linkMap[getLang()];
      if (!link) return window.open('https://twitter.com/NIKKE_en', '_blank');
      if (isMobile()) return window.open(link.mobile, '_blank');
      return window.open(link.pc, '_blank');
    },
    getOpenFacebookLink(e: Event) {
      e.preventDefault();
      return window.open('https://www.facebook.com/TW.NIKKE/', '_blank');
    },
    getOpenNarLink(e: Event){
      e.preventDefault();
      return window.open('https://game.naver.com/lounge/nikke/board/11/', '_blank');
    },
    toPolicy(type: 'cookie' | 'privacy' = 'cookie') {
      const map = {
        cookie: this.$t('cookiesLink'),
        privacy: this.$t('privacyLink'),
      };
      const url = map[type]
      window.open(url, '_blank');
    },
    selectArea(event: any) {
      const { value } = event.target;
      if (!value) return;
      this.areaId = String(value);
    },
    selectRole(event: any) {
      const { value } = event.target;
      if (!value) return;
      this.roleId = String(value);
    },
    clickLink() {
      reportTlog({
        action: "one_year_live_reserve_btn",
        sub_action: "cm_click",
        ext_content: {
          areaid: this.areaId,
        }
      })
    },
    clickGift() {
      reportTlog({
        action: "one_year_gift_btn",
        sub_action: "cm_click",
        ext_content: {
          areaid: this.areaId,
        }
      })
    },
    async getWordAttitude(word: string, callback: Function){
      if (!word || !word.trim()) {
        this.showMessage("The content is empty\nPlease re-enter")
        callback(undefined, "");
        return;
      };
      try {
        const res = await RecordMessage0101(word);
        if (!res || (res.code !== 0 && res.code !== 503601)) {
          callback(undefined, "");
          return;
        };
        const { result = 0, sentiment_type  } = res.data || {};
        let sentiment: number = {
          [SentimentType.Positive]: 1,
          [SentimentType.Negative]: 0,
          [SentimentType.Neutral]: 0,
        }[sentiment_type || SentimentType.Negative];
        if (res.code === 503601) {
          sentiment = 503601;
        }
        if (result === 1) {
          this.shouldReward = true;
        } else {
          this.shouldReward = false;
        }
        // 0、不合规 1、正面；2、负面
        callback(result, sentiment);
        this.appendRewardShip()
      } catch (e) {
        console.error(e)
        const talkInputBox = window.$("#talkInputBox");
        if (!talkInputBox) return;
        talkInputBox.removeClass("waiting");
      }
    },
    longTouch(dom: any, callback: Function, duration = 1000){
      // TODO pc 判断长按
      let timeOutEvent = 0 // 用来设置定时器，且 0 数值用于后续判断
      dom.on('touchstart', function(e: Event) {
        // 阻止它的默认事件
        // e.preventDefault()
        // 当开始触摸的时候定时器计时
        timeOutEvent = setTimeout(function() {
            timeOutEvent = 0
            console.log('你长按了')
            callback()
        }, duration) // 达到 1s 就会实现长按效果
      })
      dom.on('touchmove', function(e: Event) {
        // 如果触摸未达到 1s 且开始移动，则清除计时器
        clearTimeout(timeOutEvent)
        timeOutEvent = 0
      })
      dom.on('touchend', function(e: Event) {
        // 如果触摸未达到 1s 且离开屏幕，则清除计时器
        clearTimeout(timeOutEvent)
        if (timeOutEvent !== 0) {
          // 判断是否发生长按
            console.log('你这是点击，不是长按')
        }
        // return false
      })
    },
    appendShareChannel() {
      const shareChannelMap = {
        en: ['twitter', 'facebook'],
        th: ['twitter', 'facebook', 'line'],
        ja: ['twitter', 'line'],
        ko: ['kakao', 'twitter'],
        zh: ['twitter', 'facebook', 'line'],
      };
      const shareChannel = shareChannelMap[this.language as keyof typeof shareChannelMap];
      const divs = shareChannel.map(channel => {
        if (channel === 'kakao' && !this.showKakao) return;
        if (channel === 'line' && !this.showLine) return;
        const divDom = window.$(`<div class="item item_${channel}" style="display: block;"></div>`);
        divDom.on('click', () => {
          console.log('click', channel);
          this.share(channel);
        })
        return divDom;
      })
      window.$('.sns').empty().append(divs)
    },
    changePage(id: string) {
      (window as any).gm.changePage(id);
    },
    appendRewardShip(should = false) {
      let shouldReward = this.shouldReward;
      if (this.language !== 'en') {
        shouldReward = should;
      }
      this.shouldReward = shouldReward;
      if (shouldReward) {
        const share_tips = window.$(`<div class="share_tips"></div>`)
        window.$('.sns').append(share_tips);
      }
    }
  },
});
